export const BILLING_INTERVALS = {
  MONTHLY: "monthly",
  ANNUAL: "annual",
};

export const BILLING_INTERVAL_OPTIONS = [
  { id: BILLING_INTERVALS.MONTHLY, label: "Mensal", suffix: "/mês" },
  // Anual mostra o equivalente mensal (o total cobrado por ano aparece embaixo).
  { id: BILLING_INTERVALS.ANNUAL, label: "Anual", suffix: "/mês" },
];

export const PLAN_KINDS = {
  FREE: "free",
  PAID: "paid",
  ENTERPRISE: "enterprise",
};

// `planKeys` são as plano_chave do catálogo do backend (core/billing/catalogo.py).
// Preços não ficam aqui: vêm de GET /billing/planos.
export const PLANS = [
  {
    id: "free",
    kind: PLAN_KINDS.FREE,
    name: "Básico",
    permissions: [
      "Pedidos de cirurgia ilimitados",
      "Recurso técnico de glosa",
      "Até 3 pacotes de cirurgia",
      "Até 3 pacotes de OPME",
    ],
    ctaLabel: "Começar grátis",
  },
  {
    id: "premium",
    kind: PLAN_KINDS.PAID,
    name: "Premium",
    permissions: [
      "Tudo do plano Básico",
      "Até 15 pacotes de cirurgia",
      "Até 15 pacotes de OPME",
      "Voz para texto na transcrição",
      "Leitor OCR de documentos e códigos",
    ],
    planKeys: {
      [BILLING_INTERVALS.MONTHLY]: "premium_mensal",
      [BILLING_INTERVALS.ANNUAL]: "premium_anual",
    },
    ctaLabel: "Assinar Premium",
    mostPopular: true,
  },
  {
    id: "professional",
    kind: PLAN_KINDS.PAID,
    name: "Profissional",
    permissions: [
      "Tudo do plano Premium",
      "Pacotes de cirurgia e OPME ilimitados",
      "Suporte prioritário",
    ],
    planKeys: {
      [BILLING_INTERVALS.MONTHLY]: "profissional_mensal",
      [BILLING_INTERVALS.ANNUAL]: "profissional_anual",
    },
    ctaLabel: "Assinar Profissional",
  },
  {
    id: "empresarial",
    kind: PLAN_KINDS.ENTERPRISE,
    name: "Empresarial",
    permissions: [
      "Tudo do plano Profissional",
      "Licenças para múltiplos profissionais",
      "Integrações sob demanda (API, relatórios, SSO)",
    ],
    ctaLabel: "Falar com vendas",
  },
];
